
export const ConnectVariantButton = ({
    onClickCallback,
    isLoading,
    isDisabled,
}) => {
    return (
        <button
            onClick={(e) => onClickCallback?.(e)}
            disabled={isLoading || isDisabled}
            className="h-fit whitespace-nowrap inline-flex items-center px-2.5 py-1.5 text-xs font-medium rounded text-blue-700 bg-blue-50 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
        >
            <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Connect Variant
        </button>
    )
}